var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "c196fe7cc74e7f98b6ad4258d7421fbdddecc86e"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-ca@rodi"] = {
  id: "c196fe7cc74e7f98b6ad4258d7421fbdddecc86e"
};